import Action from "./types";

export const handleUpdateHistogram = packet => dispatch => {
  dispatch({ type: Action.HISTOGRAM_UPDATE_DATA, value: packet });
};
